import styled from 'styled-components';

export const StepField = styled.div`
  width: 220px;
`;

export const FieldInfo = styled.span`
  margin-top: 4px;
  max-width: 275px;

  font-size: ${props => props.theme.sizeExtraSmall};
  color: ${props => props.theme.gray85};
`;

export const DisablableWrapper = styled.div<{ disable: boolean }>`
  opacity: ${({ disable }) => (disable ? 0.5 : 1)};
  pointer-events: ${({ disable }) => (disable ? 'none' : 'auto')};
`;
